import React, { Fragment } from "react";
import { Route, Routes } from "react-router-dom";
import LoginContainer from "../containers/login/LoginContainer";
import { TokenLogin } from "../containers/login/TokenLogin";
import UserAdminContainer from "../containers/useradmin/UserAdminContainer";
import Welcome from "../containers/welcome/Welcome";
import { useAuth } from "../hooks/useAuth";
import ProfilContainer from "../containers/profil/ProfilContainer";
import ResetPasswordContainer from "../containers/resetPassword/resetPasswordContainer";
import DnnSpinningContainer from "../containers/dnnSite/DnnSpinningContainer";
import LoginWelcome from "../containers/login/components/LoginWelcome";
import { TokenLoginCaseDet } from "../containers/login/TokenLoginCaseDet";
import NewCaseContainer from "../containers/caseNew/NewCaseContainer";
import NewCaseRedirect from "../containers/caseNew/NewCaseRedirect";
import OversiktContainer from "../containers/oversikt/OversiktContainer";
import FilebehandlingContainer from "../containers/filbehandling/FilbehandlingContainer";
import CasesMRUContainer from "../containers/CasesMRU/CasesMRUContainer";
import { SpinnerDnnLoginRedirect } from "../containers/dnnSite/dnnFunctions";
import HeadlessCmsContainer from "../containers/headlessCMS/HeadlessCmsContainer";
import InterestCalculatorContainer from "../containers/interestCalculator/InterestCalculatorContainer";
import { CaseListReduxContainer } from "../containers/caselist_redux/CaseListReduxContainer";
import DummyContainer from "../containers/dummy/DummyContainer";
import CaseDetailsContainerRedux from "../containers/caseDetailsRedux/CaseDetailsContainer";
import FakturaAdminContainer from "../containers/fakturaAdminContainer/FakturaAdminContainer";
import KontaktSideContainer from "../containers/kontaktSide/KontaktSideContainer";
import { useRefreshTokenAutoLogout } from "../components/LogoutWarning/useRefreshTokenAutoLogout";
import { PbiReportContainer } from "../containers/pbiReport/PbiReportContainer";
import PbiTabContainer from "../containers/pbiTabContainer/PbiTabContainer";
import WelcomeNoAccess from "../containers/WelcomeNoAccess/WelcomeNoAccess";
import MfaContainer from "../containers/mfa/MfaContainer";
import WsUserLoginContainer from "../containers/wsuserlogin/WsUserLoginContainer";
import CONFIG from "../config";
import StengelisteContainer from "../containers/stengeliste/StengelisteContainer";
import KredittvurderingContainer from "../containers/kredittvurdering/KredittvurderingContainer";
import OnboardingContainer from "../onboarding/containers/OnboardingContainer.js";
import OnboardingSetupWrapper from "../onboarding/containers/OnboardingSetupWrapper";
import ClientManagementContainer from "../onboarding/containers/ClientManagementContainer";
import { canAccessPortal, canAccessMainPortal, canAccessProfile, canAccessOnboardingSetup, canAccessAdminFeatures } from "../utils/routeGuards";

const KfRoutes = () => {
  const auth = useAuth();

  const isAdmin = () => {
    if (auth.isSupervisor()) return true;
    if (auth.isForeningSupervisor()) return true;
    return false;
  };

  const { displayLogoutWarning } = useRefreshTokenAutoLogout();

  console.log("ForcemfaNow() returns :", auth.forceMfaNow());

  if (auth.forceMfaNow()) {
    //if (auth.user.forceMfaNow !== 'false') {
    //console.log("Du må sette opp mfa", auth)
    return (
      <Fragment>
        <Routes>
          <Route path="/KontaktSkjema" element={<KontaktSideContainer />} />
          <Route path="/profil" element={<ProfilContainer />} />
          <Route path="*" element={<MfaContainer />} />
        </Routes>
      </Fragment>
    );
  }

  return (
    <Fragment>
      {displayLogoutWarning()}
      <Routes>
        {/* Hjem */}
        <Route
          path="/"
          element={auth.isAuthenticated ? <LoginWelcome /> : <Welcome />}
        />

        {/* Filbehandling */}
        <Route
          path="/Filbehandling"
          element={
            canAccessMainPortal(auth) ? (
              <FilebehandlingContainer />
            ) : (
              <Welcome />
            )
          }
        />

        {/* Saksliste */}
        <Route
          path="/caselist"
          element={
            canAccessPortal(auth) ? (
              <CaseListReduxContainer />
            ) : (
              <Welcome />
            )
          }
        />

        {/* Dummy */}
        <Route
          path="/Dummy"
          element={auth.isAuthenticated ? <DummyContainer /> : <Welcome />}
        />

        {/* CasesMRU */}
        <Route
          path="/casesmru"
          element={
            canAccessMainPortal(auth) ? (
              <CasesMRUContainer />
            ) : (
              <Welcome />
            )
          }
        />

        {/* Profil */}
        <Route
          path="/profil"
          element={
            canAccessProfile(auth) ? <ProfilContainer /> : <LoginContainer />
          }
        />

        {/* MFA registreringng  */}
        <Route
          path="/mfa"
          element={auth.isAuthenticated ? <MfaContainer /> : <LoginContainer />}
        />


        {/* Onboarding*/}
        <Route path="/onboarding" element={<OnboardingContainer />} />
        <Route
          path="/onboarding/setup"
          element={
            canAccessOnboardingSetup(auth) ? <OnboardingSetupWrapper /> : <Welcome />
          }
        />
        <Route 
          path="/client-onboardings" 
          element={
            canAccessAdminFeatures(auth) ? <ClientManagementContainer /> : <Welcome />
          }
        />

        {/* BrukerAdmin */}
        <Route
          path="/brukere"
          element={
            canAccessAdminFeatures(auth) ? (
              <UserAdminContainer resetTrigger={Math.random()} />
            ) : (
              <Welcome />
            )
          }
        />

        {/* logout trengs ikke, det gjøres med auth.logOut rett fra menyen */}
        {/* <Route exact path="/login/:username?/:crNo?/:caseId?" element={LoginContainer} /> */}

        {/* Sendes til casedetails, eller via login bilde dersom ikke pålogget */}
        <Route path="/login" element={<LoginContainer />} />
        <Route path="/login/:username" element={<LoginContainer />} />
        <Route path="/login/:username/:crNo" element={<LoginContainer />} />
        <Route
          path="/login/:username/:crNo/:caseId"
          element={<LoginContainer />}
        />

        <Route path="/tokenlogin/:token" element={<TokenLogin />} />

        <Route
          path="/tokenLoginCaseDet/:crNo/:caseId/:token"
          element={<TokenLoginCaseDet />}
        />

        <Route path="/BanqsoftPortal" element={<SpinnerDnnLoginRedirect />} />

        <Route path="/dnnlogin" element={<dnnContainer />} />

        <Route
          path="/resetpassword/:token/:email"
          element={<ResetPasswordContainer />}
        />

        <Route path="/dnntransfer" element={<DnnSpinningContainer />} />

        {CONFIG.WSUSER_TOKENLOGIN && (
          <Route
            path="/wsuserlogin/:crNo/:caseId/:token"
            element={<WsUserLoginContainer />}
          />
        )}

        {/* Saksdetaljer */}
        <Route
          path="/CaseDetails/:crNo/:caseId"
          element={
            canAccessMainPortal(auth) ? (
              <CaseDetailsContainerRedux />
            ) : (
              <Welcome />
            )
          }
        />

        {/* Ny sak */}
        <Route
          path="/CaseNew/init"
          element={
            canAccessMainPortal(auth) ? (
              <NewCaseRedirect resetTrigger={Math.random()} />
            ) : (
              <Welcome />
            )
          }
        />

        {/* Ny sak */}
        <Route
          path="/CaseNew"
          element={
            canAccessMainPortal(auth) ? (
              <NewCaseContainer resetTrigger={Math.random()} />
            ) : (
              <Welcome />
            )
          }
        />

        {/* Oversikt */}
        <Route
          path="/Overview"
          element={
            canAccessMainPortal(auth) ? (
              <OversiktContainer />
            ) : (
              <Welcome />
            )
          }
        />

        {/* Start reports menu */}
        <Route
          path="/Reports/Main"
          element={
            canAccessMainPortal(auth) ? (
              <PbiTabContainer />
            ) : (
              <Welcome />
            )
          }
        />

        {/* Ikke i bruk lenger */}
        <Route
          path="/Reports/Run/:reportId"
          element={
            canAccessMainPortal(auth) ? (
              <PbiReportContainer />
            ) : (
              <Welcome />
            )
          }
        />

        {/* HeadlessCMS (Ahlin) */}
        <Route
          path="/HeadlessCMS/:id"
          element={
            auth.isAuthenticated ? <HeadlessCmsContainer /> : <Welcome />
          }
        />

        {/* FakturaAdmin */}
        <Route
          path="/fakturaadmin"
          element={
            canAccessMainPortal(auth) ? (
              <FakturaAdminContainer />
            ) : (
              <Welcome />
            )
          }
        />
        {/* Kontaktskjema */}
        <Route path="/KontaktSkjema" element={<KontaktSideContainer />} />

        {/* Ingen kreditor */}
        <Route path="/WelcomeNoAccess" element={<WelcomeNoAccess />} />

        {/* Stengeliste */}
        <Route
          path="/stengeliste"
          element={
            canAccessMainPortal(auth) ? (
              <StengelisteContainer />
            ) : (
              <Welcome />
            )
          }
        />

        {/* Kredittvurdering */}
        <Route
          path="/kredittvurdering"
          element={
            canAccessMainPortal(auth) ? (
              <KredittvurderingContainer />
            ) : (
              <Welcome />
            )
          }
        />

        {/* RenteKalkulator (i hamburgermeny) */}
        <Route
          path="/RenteKalkulator"
          element={<InterestCalculatorContainer />}
        />
      </Routes>
    </Fragment>
  );
};

export default KfRoutes;
